import React from 'react'

export default function asyncComponent(importCompoent) {
    
    class AsyncComponent extends React.Component {

        state = {
            component: null
        }

        async componentDidMount () {
            const { default: component } = await importCompoent();
            this.setState({ component })
        }

        render() {
            const C: any = this.state.component;
            return C ? <C {...this.props} /> : null
        }
    }

    return AsyncComponent
}